var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_268",
    "data-name": "Grupo 268",
    transform: "translate(-367.52 -408.049)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_71",
    "data-name": "Elipse 71",
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    transform: "translate(367.52 408.049)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1505",
    "data-name": "Caminho 1505",
    d: "M457.037,512.337c-10.655-4.584-14-8.417-14-16.667,0-4.95,3.234-3.334,4.659-12.405.594-3.749,3.459-.059,4.015-8.643,0-3.418-1.562-4.268-1.562-4.268s.791-5.068,1.105-8.964a15.451,15.451,0,0,0-11.5-15.48c-1.665-1.7-2.79-4.406,2.331-7.118-11.214-.525-13.811,5.333-19.773,9.643h0a15.643,15.643,0,0,0-6.194,12.948c.313,3.894,1.11,8.965,1.11,8.965s-1.562.85-1.562,4.268c.544,8.583,3.415,4.88,4.006,8.643,1.418,9.061,4.665,7.455,4.665,12.4,0,8.243-3.4,12.1-14.014,16.667-6.38,2.745-12.9,5.935-17.092,10.213a62.44,62.44,0,0,0,80.911,0C469.951,518.274,463.437,515.09,457.037,512.337Z",
    transform: "translate(-3.661 -4.373)",
    fill: "#d2d1d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPhoto);
export default __webpack_public_path__ + "static/media/default_photo.5efa95be705739ddc4194bf5e1638991.svg";
export { ForwardRef as ReactComponent };